
export class Channels {
    colorChannels = [];
    circleColors = [{ text: 'Direct', color: '#90527f', class: 'm--hidden-direct', classTrend: 'm--hidden-direct-trends' },
    { text: 'Email', color: '#000', class: 'm--hidden-mail', classTrend: 'm--hidden-mail-trends' },
    { text: 'Display', color: '#000', class: 'm--hidden-display', classTrend: 'm--hidden-display-trends' },
    { text: 'Organic Search', color: '#50ada5', class: 'm--hidden-organic', classTrend: 'm--hidden-organic-trends' },
    { text: 'Referral', color: '#3e5d7a', class: 'm--hidden-referral', classTrend: 'm--hidden-referral-trends' },
    { text: 'Social', color: '#329aca', class: 'm--hidden--social', classTrend: 'm--hidden--social-trends' },
    { text: 'Paid Search', color: '#ec5155', class: 'm--hidden--paid', classTrend: 'm--hidden--paid-trends' },
    { text: '(Other)', color: '#262626', class: 'm--hidden--other', classTrend: 'm--hidden--other-trends' },]


}


// WEBPACK FOOTER //
// ./src/app/components/rtb/class/channels.service.ts